import type { User } from 'firebase/auth'
import { createContext } from 'react'

export interface CWAUser {
  name: string
  consumerId: string
  agreedToTermsAndConditions: boolean
  latestTermsVersionAgreedTo: string
  submittedAppReviewDate: string
  firebaseId: string // Firebase Auth UID
}

interface IAuthContextValue {
  logout: () => void
  reloadUser: () => void
  user?: CWAUser | null
  firebaseUser?: User | null
  /**
   * True while Firebase has not yet definitively responded with an auth state.
   * The 3-second fallback sets `firebaseInitialized` (shows children) but does
   * NOT clear this flag — routes that require authentication should gate
   * redirects on `!firebaseAuthLoading` to avoid sending signed-in users to `/`
   * on a slow Firebase initialization.
   */
  firebaseAuthLoading?: boolean
}

const AuthContextDefaultState: IAuthContextValue = {
  logout: () => {
    /** @todo Implement default function */
  },
  reloadUser: () => {
    /** @todo Implement default function */
  },
  user: null,
}

export const AuthContext = createContext(AuthContextDefaultState)
